/**教学单元模块 */
import request from '../request/http';
/**获取教学单元列表 */
export function GetTeachingUnitList(data){
    return request({
        url: '/sp/teachingUnit/getTeachingUnitList',
        method: 'post',
        data
    })
}
/**更新教学单元 */
export function UpdateTeachingUnit(data){
    return request({
        url: '/sp/teachingUnit/updateTeachingUnit',
        method: 'post',
        data
    })
}
/**删除教学单元 */
export function DelTeachingUnit(data){
    return request({
        url: '/sp/teachingUnit/delTeachingUnit',
        method: 'post',
        data
    })
}